import { render, staticRenderFns } from "./CoreLayout.vue?vue&type=template&id=109ee694&"
import script from "./CoreLayout.vue?vue&type=script&lang=js&"
export * from "./CoreLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports